export default "__VITE_ASSET__DwapBhlu__"